import { ErrorStateMatcher } from '@angular/material/core'
import {AbstractControl, UntypedFormControl} from '@angular/forms'

export class PriceRangeErrorMatcher implements ErrorStateMatcher {
  private readonly isOptional: boolean

  constructor(
    isOptional = false,
  ) {
    this.isOptional = isOptional
  }

  isErrorState(control: UntypedFormControl): boolean {
    if (control.value.length && control.value <= 0) return true
    if (!control || !control.touched) return false
    if (control.parent.parent.parent.errors) return true
    if (this.isOptional) return false
    return !(control.value || '').trim()?.length
  }
}
